<template>
  <app-header></app-header>
  <section class="catalog history-review">
    <div class="title-box">
      <h1 class="title">{{ $t('history-review.key001') }}</h1>
    </div>
    <div class="products-list">
      <div class="product-item" v-for="item in historyProducts" :key="item.id">
        <div class="product-info" @click="viewProduct(item.eventRoute)">
          <img :src="item.image" alt="" class="" />
          <div class="text-info">
            <div class="time">
              <p>
                <i class="bi bi-calendar-week"></i>
                <span>{{ item.time }}</span>
              </p>
            </div>
            <div class="text">
              <h2 class="title" :title="item.name">
                {{ item.name }}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-footer></app-footer>
</template>
<script>
import AppHeader from '@/components/Header.vue';
import AppFooter from '@/components/Footer.vue';
import { historyProducts } from '@/api/infoSerivce.js';
export default {
  name: 'history-review',
  components: {
    'app-header': AppHeader,
    'app-footer': AppFooter,
  },
  mounted() {
    this.fetchHistoryProducts();
  },
  data() {
    return {
      historyProducts: [],
    };
  },
  props: {},
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  methods: {
    async fetchHistoryProducts() {
      try {
        this.loading = true;
        const langSetting = this.currentLanguage === 'zh_tw' ? 'zh-tw' : this.currentLanguage;
        const response = await historyProducts(langSetting);
        this.historyProducts = response.data.data;
        const historyProductsData = this.historyProducts;
        if (historyProductsData) {
          historyProductsData.forEach((item) => {
            if (item.startTime && item.endTime) {
              item.time = this.formatTimeRange(item.startTime, item.endTime);
            }
          });
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        this.loading = false;
      }
    },
    formatTimeRange(startTime, endTime) {
      const startDate = new Date(startTime);
      const endDate = new Date(endTime);

      const formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');

        this.timeZone = date.toString().match(/\(([^)]+)\)$/)[1];
        return `${yyyy}/${mm}/${dd}`;
      };

      const formattedStart = formatDate(startDate);
      const formattedEnd = formatDate(endDate);

      return `${formattedStart} ~ ${formattedEnd}`;
    },
    viewProduct(eventRoute) {
      this.$router.push({
        path: `/${this.currentLanguage}/history-review-detail`,
        query: {
          eventRoute: eventRoute,
        },
      });
    },
  },
};
</script>
